import firebase from 'firebase';
import { db, functions } from '@/firebase';
// firebase.functions().useEmulator('127.0.0.1', 5001);

export default {
  getUsuariosAll({ dispatch }) {
    return Promise.all([dispatch('getUsuarios'), dispatch('getUsuariosCall')]);
  },
  getUsuarios({ commit }) {
    let u = [];
    return db
      .collection('users')
      .get()
      .then((qSnap) => {
        qSnap.forEach(function (doc) {
          let aux = doc.data();
          aux.id = doc.id;
          u.push(aux);
        });
        commit('setUsers', u);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getUsuariosRol({ commit }, rol) {
    return db
      .collection('users')
      .where('role', '==', rol)
      .get()
      .then((qSnap) => {
        commit(
          'setUsers',
          qSnap.docs.map((u) => {
            return {
              ...u.data(),
              id: u.id,
            };
          })
        );
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getUsuarioCampo({ commit }, { rol, campo, campoUsuario }) {
    if (campoUsuario == 'uid') {
      return db
        .collection('users')
        .doc(campo)
        .get()
        .then((u) => {
          if (u.exists) {
            commit('setUsers', [
              {
                ...u.data(),
                id: u.id,
              },
            ]);
          } else {
            commit('setUsers', []);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      return db
        .collection('users')
        .where('role', '==', rol)
        .where(campoUsuario, '==', campo)
        .get()
        .then((qSnap) => {
          commit(
            'setUsers',
            qSnap.docs.map((u) => {
              return {
                ...u.data(),
                id: u.id,
              };
            })
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
  getUsuariosCall({ commit }) {
    var f = firebase.functions().httpsCallable('httpUsersGetUsers');
    return f()
      .then((res) => {
        commit('setUsersAuth', res.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  },
  addUserAdmin({}, user) {
    Object.keys(user).forEach(
      (key) => (user[key] == null || user[key] == '') && delete user[key]
    );
    var f = firebase.functions().httpsCallable('httpUsersAddUser');
    return f(user);
  },
  changePassUserAdmin({}, user) {
    var f = firebase.functions().httpsCallable('httpUsersChangePassUser');
    return f(user);
  },
  changePerfilUserAdmin({}, user) {
    var f = firebase.functions().httpsCallable('httpUsersUpdateProfileUser');
    return f(user);
  },
  saveRestaurantesGest({}, user) {
    let id = user.id;
    delete user.id;
    return db.collection('users').doc(id).set(user, { merge: true });
  },

  deleteUser({}, user) {
    var f = firebase.functions().httpsCallable('httpUsersDeleteUser', user);
    return f(user.uid);
  },
  changeDisabled({}, user) {
    var f = firebase.functions().httpsCallable('changeDisabled');
    return f({
      uid: user.uid,
      bool: !user.activo,
    }).then((res) => {
      let datos = res.data;
      if (datos.ok) {
        let a = {
          ok: true,
          b: datos.b,
        };
        return a;
      } else {
        let a = {
          ok: false,
          errorCode: datos.error,
        };
        return a;
      }
    });
  },
  getUsuario({ commit }, idUsuario) {
    return db
      .collection('users')
      .doc(idUsuario)
      .get()
      .then((u) => {
        if (u.exists) {
          let datos = {
            ...u.data(),
            id: u.id,
          };
          commit('setUsuarioViendo', datos);
          return datos; //devolvemos por si se quiere utilizar sin que sea desde vuex
        } else {
          return {};
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getPedidosUsuario({ state }, idUsuario = null) {
    if (!idUsuario) idUsuario = state.usuarioViendo.id;
    return db
      .collection('pedidos')
      .where('uid', '==', idUsuario)
      .orderBy('fechaServidor', 'desc')
      .get()
      .then((r) => {
        return r.size > 0
          ? r.docs.map((p) => {
              console.log(p);
              return {
                ...p.data(),
                id: p.id,
              };
            })
          : [];
      });
  },
  adaptarUsuariosV2() {
    var f = firebase.functions().httpsCallable('httpUsersAdaptarUsuarios');
    return f();
  },

  //ANTIGUAS
  newUsuario({}, user) {
    return firebase
      .auth()
      .createUserWithEmailAndPassword(user.email, user.password)
      .then((res) => {
        return db
          .collection('users')
          .doc(res.user.uid)
          .set(user)
          .then((res) => {
            let a = {
              ok: true,
            };
            return a;
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        let a = {
          ok: false,
          errorCode: errorCode,
          errorMessage: errorMessage,
        };
        return a;
      });
  },
  updateUsuario({}, user) {
    let uid = user.id;
    delete user.id;
    delete user.password;
    return db
      .collection('users')
      .doc(uid)
      .set(user, { merge: true })
      .then((res) => {
        let a = {
          ok: true,
        };
        return a;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
